import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpModule } from "@angular/http";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import {
  MapModule,
  MapAPILoader,
  MarkerTypeId,
  IMapOptions,
  IBox,
  IMarkerIconInfo,
  WindowRef,
  DocumentRef,
  MapServiceFactory,
  BingMapAPILoaderConfig,
  BingMapAPILoader,
  GoogleMapAPILoader,
  GoogleMapAPILoaderConfig,
} from "angular-maps";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ReactiveFormsModule } from "@angular/forms";
import { FormsModule } from "@angular/forms";

import {
  NbThemeModule,
  NbLayoutModule,
  NbCardModule,
  NbSidebarModule,
  NbSidebarService,
  NbMenuModule,
  NbCheckboxModule,
  NbMenuService,
  NbActionsModule,
  NbInputModule,
  NbButtonModule,
  NbCalendarModule,
  NbDatepickerModule,
  NbPopoverModule,
  NbTooltipModule,
  NbAccordionModule,
  NbToastrModule,
  NbDialogModule,
  NbSpinnerModule,
  NbUserModule,
  NbSelectModule,
  NbTabsetModule,
  NbBadgeModule,
  NbCalendarRangeModule,
  NbRadioModule,
  NbStepperModule,
} from "@nebular/theme";
import { Ng5SliderModule } from "ng5-slider";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { ChartModule } from "angular2-chartjs";
import { NbMomentDateModule } from "@nebular/moment";
import { NbDateFnsDateModule } from "@nebular/date-fns";
import { HttpClientModule } from "@angular/common/http";
import { HomeComponent } from "./public/home/home.component";
import { TransaccionesComponent } from "./public/transacciones/transacciones.component";
import { DashboardComponent } from "./public/dashboard/dashboard.component";
import { LoginComponent } from "./public/login/login.component";
import { UsuariosComponent } from "./public/usuarios/usuarios.component";
import { AnalisisComponent } from "./public/biodiversidad/analisis/analisis.component";
import { EstadisticasComponent } from "./public/biodiversidad/estadisticas/estadisticas.component";
import { EcosistemasComponent } from "./public/ecosistemas/ecosistemas.component";
import { FormulariosComponent } from "./public/formularios/formularios/formularios.component";
import { EmpresasComponent } from "./public/administracion/empresas/empresas.component";
import { CrearComponent } from "./public/formularios/crear/crear.component";
import { FormulariosEncuestasComponent } from "./public/formularios/formularios-encuestas/formularios-encuestas.component";
import { EditEmpresaComponent } from "./public/administracion/empresas/edit-empresa/edit-empresa.component";
import { EditUsuariosComponent } from "./public/usuarios/edit-usuarios/edit-usuarios.component";
import { EditarFormularioComponent } from "./public/formularios/crear/editar-formulario/editar-formulario.component";
import { ResultadosComponent } from "./public/formularios/formularios-encuestas/resultados/resultados/resultados.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { EcosistemaAnalisisComponent } from "./public/ecosistema-analisis/ecosistema-analisis.component";
import { GeomComponent } from "./public/ecosistema-analisis/geom/geom.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { LayersSlideHomeComponent } from "./public/home/componentes/layers-slide-home/layers-slide-home.component";
import { GraphsHomeComponent } from "./public/home/componentes/graphs-home/graphs-home.component";
import { MapHomeComponent } from "./public/home/componentes/map-home/map-home.component";
import { GraficoBarrasComponent } from "./public/home/componentes/graphs-home/grafico-barras/grafico-barras.component";
import { GraficoTortaComponent } from "./public/home/componentes/graphs-home/grafico-torta/grafico-torta.component";
import { GraficoLineaComponent } from "./public/home/componentes/graphs-home/grafico-linea/grafico-linea.component";
import { CardComponent } from './public/home/componentes/graphs-home/card/card.component';
import { LeyendaComponent } from './public/ecosistemas/leyenda/leyenda.component';
import { NavbarMapComponent } from './public/ecosistemas/navbar-map/navbar-map.component';
import { CommonModule } from "@angular/common";
import { InfoPanelComponent } from './public/ecosistemas/info-panel/info-panel.component';
import { CapasPrincipalesComponent } from './public/ecosistemas/capas-principales/capas-principales.component';
import { FiltroFechaComponent } from './public/ecosistemas/filtro-fecha/filtro-fecha.component';
import { CustomNavControllerComponent } from './public/ecosistemas/custom-nav-controller/custom-nav-controller.component';

export function MapServiceProviderFactory() {
  let bc: BingMapAPILoaderConfig = new BingMapAPILoaderConfig();
  bc.apiKey =
    "Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j"; // your bing map key
  bc.branch = "experimental";
  // to use the experimental bing brach. There are some bug fixes for
  // clustering in that branch you will need if you want to use
  // clustering.
  return new BingMapAPILoader(bc, new WindowRef(), new DocumentRef());
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TransaccionesComponent,
    DashboardComponent,
    LoginComponent,
    UsuariosComponent,
    EmpresasComponent,
    AnalisisComponent,
    CrearComponent,
    EstadisticasComponent,
    EcosistemasComponent,
    FormulariosComponent,
    FormulariosEncuestasComponent,
    EditEmpresaComponent,
    EditUsuariosComponent,
    EditarFormularioComponent,
    ResultadosComponent,
    EcosistemaAnalisisComponent,
    GeomComponent,
    LayersSlideHomeComponent,
    GraphsHomeComponent,
    MapHomeComponent,
    GraficoBarrasComponent,
    GraficoTortaComponent,
    GraficoLineaComponent,
    CardComponent,
    LeyendaComponent,
    NavbarMapComponent,
    InfoPanelComponent,
    CapasPrincipalesComponent,
    FiltroFechaComponent,
    CustomNavControllerComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    MapModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    NbThemeModule.forRoot({ name: "default" }),
    NbLayoutModule,
    NbSidebarModule,
    NbActionsModule,
    NbCardModule,
    NbInputModule,
    NbCheckboxModule,
    NbButtonModule,
    NbSelectModule,
    NbTooltipModule,
    NbTabsetModule,
    NbBadgeModule,
    NbCalendarModule,
    Ng2SmartTableModule,
    NbDatepickerModule.forRoot(),
    NbMenuModule.forRoot(),
    ReactiveFormsModule,
    NbToastrModule.forRoot(),
    NbDialogModule.forChild(),
    NbSpinnerModule,
    NbCalendarRangeModule,
    NbUserModule,
    NbAccordionModule,
    ChartModule,
    NbMomentDateModule,
    NbDateFnsDateModule.forRoot({ format: "dd.MM.yyyy" }),
    NbDateFnsDateModule.forChild({ format: "dd.MM.yyyy" }),
    NbDatepickerModule.forRoot(),
    HttpModule,
    HttpClientModule,
    DragDropModule,
    NbRadioModule,
    Ng5SliderModule,
    NbStepperModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
    NbSidebarService,
    NbMenuService,
    {
      provide: MapAPILoader,
      deps: [],
      useFactory: MapServiceProviderFactory,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
